// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setSaveLabelInputDiv {
  margin-bottom: 20px;
}

.setSaveLabelPDiv {
  display: flex;
}

.setSaveLabel {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 3%;
  width: 20%;
  /* margin-left: 9%; */
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.setSaveInput {
  box-sizing: border-box;
  width: 30%;
  position: relative;
  height: 32px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
}

.viewSetContainer {
  background: #ffffff;
  padding: 15px;
  margin-bottom: 15px;
  box-sizing: border-box;
  color: #797979;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  box-shadow: 3px 3px 3px 3px #aab2bd;
  /* margin-left: 15%;
  margin-right: 15%; */ /* Safari & IE */
  position: sticky;
  top: 60px;
  z-index: 1;
}

/* .viewSearchOne {
  margin-left: 15.5%;
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
} */
.viewSetSearchTwo {
  margin-left: 15.5%;
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
}

.viewSetSearch:hover {
  background-color: #51cac2;
}

.viewSetSearch:active {
  background-color: #327e79;
}

.setSaveTable,
.setSaveTable th,
.setSaveTable td {
  border: 1px solid #797979;
  border-collapse: collapse;
  font-weight: 500;
  margin-bottom: 30px;
}

.setSaveTable th,
.setSaveTable td {
  padding: 10px;
  text-align: center;
}

.viewTableContainer {
  height: 740px;
  margin: 0 5%;
  margin-bottom: 20px;
  overflow-y: auto;
}

.qsetNumberDiv {
  width: 25px;
}

.qsetShortDiv {
  margin-left: 20px;
  width: 440px;
}

.qsetCheckbox {
  margin-top: 120%;
  margin-right: 10px;
}

.viewQSetTableContainer {
  height: 400px;
  margin: 0 3%;
  margin-bottom: 20px;
  overflow-y: auto;
  width: 45%;
}

.setRemoveButton {
  margin-top: 28px;
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 4px 8px;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.setRemoveButton:hover {
  background-color: #51cac2;
}
.setRemoveButton:active {
  border: 1px solid #03afa9 !important;
}

.summarySaveSetButton {
  margin-top: 28px;
  margin-left: 7px;
  color: #fff;
  background-color: #68dff0;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  padding: 4px 8px;
  margin-bottom: 0;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid #48bcb4;
  border-radius: 4px;
  cursor: pointer;
}

.setSummaryNameDiv {
  width: 50%;
  /* margin-top: 100px; */
}

.setSaveSummaryP {
  margin-top: 10px;
  font-weight: 600;
}

.setSaveInputSummary {
  box-sizing: border-box;
  width: 57%;
  position: relative;
  height: 32px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
}

.setSaveLabelSummary {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 10px;
  width: 20%;
  max-width: 20%;
  margin-left: 5px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.setSaveLabelSummary::after {
  content: "*";
  color: #797979;
  margin-left: 2px;
}

.setSaveLabelSummaryNoStar {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 5px;
  font-weight: 500;
  margin-right: 10px;
  width: 20%;
  max-width: 20%;
  margin-left: 5px;
  color: #797979;
  font-family: "Ruda", sans-serif;
}

.setSaveTextareaSummary {
  box-sizing: border-box;
  width: 57%;
  position: relative;
  height: 50px;
  padding-right: 15px;
  padding-left: 15px;
  color: #555;
  font-family: "Ruda", sans-serif;
  font-size: 13px;
  line-height: 1.42857143;
  margin-left: 4%;
  margin-right: 11%;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline-color: #68dff0;
}

.QSetCreatorSummaryDiv {
  width: 49%;
  height: 400px;
  overflow-y: auto;
}

.QSetCreatorh4PDiv {
  display: flex;
  flex-direction: row;
}

.qSetCreatorTotalMarksP {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 20px;
  font-family: "Ruda", sans-serif;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
  margin-left: 100px;
}

.viewTopic {
  margin-left: 38px;
  margin-top: -5px;
}

.viewTablePaginationQSet {
  width: 48%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/QSetCreator/qsetCreator.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC;sBACoB,EACM,gBAAgB;EAC1C,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;GAgBG;AACH;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".setSaveLabelInputDiv {\n  margin-bottom: 20px;\n}\n\n.setSaveLabelPDiv {\n  display: flex;\n}\n\n.setSaveLabel {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 3%;\n  width: 20%;\n  /* margin-left: 9%; */\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.setSaveInput {\n  box-sizing: border-box;\n  width: 30%;\n  position: relative;\n  height: 32px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n}\n\n.viewSetContainer {\n  background: #ffffff;\n  padding: 15px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  box-shadow: 3px 3px 3px 3px #aab2bd;\n  /* margin-left: 15%;\n  margin-right: 15%; */\n  position: -webkit-sticky; /* Safari & IE */\n  position: sticky;\n  top: 60px;\n  z-index: 1;\n}\n\n/* .viewSearchOne {\n  margin-left: 15.5%;\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n} */\n.viewSetSearchTwo {\n  margin-left: 15.5%;\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.viewSetSearch:hover {\n  background-color: #51cac2;\n}\n\n.viewSetSearch:active {\n  background-color: #327e79;\n}\n\n.setSaveTable,\n.setSaveTable th,\n.setSaveTable td {\n  border: 1px solid #797979;\n  border-collapse: collapse;\n  font-weight: 500;\n  margin-bottom: 30px;\n}\n\n.setSaveTable th,\n.setSaveTable td {\n  padding: 10px;\n  text-align: center;\n}\n\n.viewTableContainer {\n  height: 740px;\n  margin: 0 5%;\n  margin-bottom: 20px;\n  overflow-y: auto;\n}\n\n.qsetNumberDiv {\n  width: 25px;\n}\n\n.qsetShortDiv {\n  margin-left: 20px;\n  width: 440px;\n}\n\n.qsetCheckbox {\n  margin-top: 120%;\n  margin-right: 10px;\n}\n\n.viewQSetTableContainer {\n  height: 400px;\n  margin: 0 3%;\n  margin-bottom: 20px;\n  overflow-y: auto;\n  width: 45%;\n}\n\n.setRemoveButton {\n  margin-top: 28px;\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 4px 8px;\n  margin-bottom: 0;\n  font-size: 11px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.setRemoveButton:hover {\n  background-color: #51cac2;\n}\n.setRemoveButton:active {\n  border: 1px solid #03afa9 !important;\n}\n\n.summarySaveSetButton {\n  margin-top: 28px;\n  margin-left: 7px;\n  color: #fff;\n  background-color: #68dff0;\n  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);\n  padding: 4px 8px;\n  margin-bottom: 0;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  border: 1px solid #48bcb4;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.setSummaryNameDiv {\n  width: 50%;\n  /* margin-top: 100px; */\n}\n\n.setSaveSummaryP {\n  margin-top: 10px;\n  font-weight: 600;\n}\n\n.setSaveInputSummary {\n  box-sizing: border-box;\n  width: 57%;\n  position: relative;\n  height: 32px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n}\n\n.setSaveLabelSummary {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 10px;\n  width: 20%;\n  max-width: 20%;\n  margin-left: 5px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.setSaveLabelSummary::after {\n  content: \"*\";\n  color: #797979;\n  margin-left: 2px;\n}\n\n.setSaveLabelSummaryNoStar {\n  font-size: 16px;\n  margin-top: 8px;\n  margin-bottom: 5px;\n  font-weight: 500;\n  margin-right: 10px;\n  width: 20%;\n  max-width: 20%;\n  margin-left: 5px;\n  color: #797979;\n  font-family: \"Ruda\", sans-serif;\n}\n\n.setSaveTextareaSummary {\n  box-sizing: border-box;\n  width: 57%;\n  position: relative;\n  height: 50px;\n  padding-right: 15px;\n  padding-left: 15px;\n  color: #555;\n  font-family: \"Ruda\", sans-serif;\n  font-size: 13px;\n  line-height: 1.42857143;\n  margin-left: 4%;\n  margin-right: 11%;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  outline-color: #68dff0;\n}\n\n.QSetCreatorSummaryDiv {\n  width: 49%;\n  height: 400px;\n  overflow-y: auto;\n}\n\n.QSetCreatorh4PDiv {\n  display: flex;\n  flex-direction: row;\n}\n\n.qSetCreatorTotalMarksP {\n  font-size: 18px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  font-family: \"Ruda\", sans-serif;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n  margin-left: 100px;\n}\n\n.viewTopic {\n  margin-left: 38px;\n  margin-top: -5px;\n}\n\n.viewTablePaginationQSet {\n  width: 48%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
